import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=5f6a12b9"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./Content.vue?vue&type=style&index=0&id=5f6a12b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports